<dx-toolbar class="toolbar">
  <dxi-item location="before" widget="dxTextBox">
    <dx-button stylingMode="outlined" icon="taskinprogress" [disabled]="true"> </dx-button>
  </dxi-item>
 <ng-container *ngIf="state !='View'">
  <dxi-item
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style=" padding-inline: 10px"
  >Form
  </dxi-item>
 </ng-container>
  <dxi-item
    *ngIf="formName"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-inline: 1px solid; padding-inline: 10px"
  >{{formName }}
  </dxi-item>
  <ng-container *ngIf="state !='View'">
  <dxi-item
    *ngIf="formAction"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-right: 1px solid; padding-inline: 10px"
  >{{formAction}}
  </dxi-item>
  </ng-container>
  <ng-container *ngIf="state !='View'">
  <dxi-item location="center" widget="dxButton" locateInMenu="never">
    <div *dxTemplate>
      <div class="toolbar-label"><b>Dabnet</b></div>
    </div>
  </dxi-item>
  </ng-container>

  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="toastMessageButtonOptions"
  >
  </dxi-item>

  <dxi-item *ngIf="this.state === 'Edit' && this.historyEntityName "
            location="after"
            widget="dxButton"
            locateInMenu="never"
            [options]="histyoryButtonOptions"
  >
  </dxi-item>
  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="infoButtonOptions"
  >
  </dxi-item>


</dx-toolbar>

<ng-container *ngIf="historyPopupVisible">
  <dx-popup
    height="82%"
    width="80%"
    [showTitle]="true"
    [position]="'center'"
    [title]="'İşlem Geçmişi'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="historyPopupVisible"
  >
    <dk-history [entityName]="historyEntityName" [selectedRowData]="historyEntityData"></dk-history>
  </dx-popup>
</ng-container>
